import { Component, inject, Input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { supportedLangs, LANGUAGE_INFO } from '../../../core/helpers/i18n/lang-mappers';
import { TranslationService } from '../../../core/services/translation-service';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-language-selector',
  imports: [MatButtonModule, MatMenuModule, TranslatePipe],
  templateUrl: './language-selector.html',
  styleUrl: './language-selector.css',
})
export class LanguageSelector {
  @Input() compact = false;

  private translationService = inject(TranslationService);
  private translateService = inject(TranslateService);

  selectedLang = this.translationService.currentLang(this.translateService);

  languages = supportedLangs.map((lang) => ({
    ...LANGUAGE_INFO[lang],
  }));

  constructor() {
    this.translateService.onLangChange.subscribe((event) => {
      this.selectedLang = event.lang;
    });
  }

  changeLang(lang: string) {
    this.translationService.changeLanguage(lang);
  }

  get currentLanguage() {
    return LANGUAGE_INFO[this.selectedLang];
  }

  getFlagUrl(flag: string): string {
    return `assets/flags/${flag}.svg`;
  }
}
